export default __webpack_public_path__ + "static/media/turkey.51a3801e.png";